var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGhost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396 884 c-79 -29 -149 -107 -166 -187 -5 -24 -11 -31 -26 -29 -84 15 -83 15 -114 -16 -52 -53 -32 -119 60 -191 l48 -38 -38 -69 c-22 -38 -39 -81 -40 -96 0 -57 107 -138 181 -138 10 0 34 -11 54 -24 20 -14 56 -28 81 -32 62 -9 127 3 169 32 20 13 44 24 54 24 74 0 181 81 181 138 -1 15 -18 58 -40 96 l-38 69 48 38 c92 72 112 138 60 191 -31 31 -30 31 -114 16 -15 -2 -21 5 -26 29 -10 47 -56 119 -93 147 -70 53 -163 69 -241 40z m160 -63 c74 -34 113 -92 123 -181 7 -66 20 -72 86 -40 110 53 96 -39 -16 -112 -48 -31 -51 -35 -45 -67 3 -18 21 -60 41 -93 19 -33 35 -65 35 -72 0 -29 -84 -76 -136 -76 -14 0 -39 -11 -55 -24 -54 -45 -164 -45 -218 0 -16 13 -41 24 -55 24 -52 0 -136 47 -136 76 0 7 16 39 35 72 20 33 38 75 41 93 6 32 3 36 -45 67 -112 73 -126 165 -16 112 66 -32 79 -26 86 40 7 63 25 104 66 142 60 57 137 72 209 39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 655 c-15 -33 3 -75 32 -75 29 0 47 42 32 75 -7 15 -20 25 -32 25 -12 0 -25 -10 -32 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 655 c-15 -33 3 -75 32 -75 29 0 47 42 32 75 -7 15 -20 25 -32 25 -12 0 -25 -10 -32 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 515 c-39 -39 -27 -50 56 -50 83 0 95 11 56 50 -16 16 -36 25 -56 25 -20 0 -40 -9 -56 -25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.1a7ed939.svg";
export { ForwardRef as ReactComponent };